import AbstractIntegration from "./AbstractIntegration.js";

/**
 * `AbstractFortnoxIntegration` is an abstract class for the Fortnox integrations
 * using the new wizard.
 *
 * @param {bool} [usesOAuth2] - Indicates whether this integration uses the legacy
 * flow (authorization token) or the new OAuth2 flow.
 */
export default class AbstractFortnoxIntegration extends AbstractIntegration {
	constructor({ usesOAuth2 = true } = {}) {
		super(...arguments);

		this._usesOAuth2 = usesOAuth2;
	}

	isOAuth2Enabled() {
		return this._usesOAuth2;
	}

	isBeta() {
		return false;
	}
}
